import { ShoppingClient } from '@udemy/shopping';
import { udApiStat } from '@udemy/ud-api';
/**
 * Resolves cart contents for FunnelEvent instances.
 * Populates the cartContents property with course IDs from the shopping cart.
 * Emits Datadog metrics for cart resolution success and failure.
 */
export function resolveCartContents(event) {
  try {
    const cartItems = ShoppingClient.lists.cart.items;
    event.cartContents = cartItems.filter(item => item.buyable && item.buyable.id != null && item.buyable.buyable_object_type).map(item => ({
      id: item.buyable.id,
      type: item.buyable.buyable_object_type
    }));
    udApiStat.increment('amplitude.web_sdk.cart_resolver.resolved', {
      event_name: event.eventName
    });
  } catch {
    // ShoppingClient may not be initialized - leave cartContents undefined
    event.cartContents = undefined;
    udApiStat.increment('amplitude.web_sdk.cart_resolver.failed', {
      event_name: event.eventName
    });
  }
}
//# sourceMappingURL=cart-resolver.js.map